const resources = {
    new: 'New',
    value: 'value',
    colors: 'Colors',
    quickLook: 'Quicklook'
};

module.exports = function getResource(label) {
    return resources[label];
};
